export default {
  toggle: ({commit, state}, value) => {
    const speed = 800
    return new Promise((resolve, reject) => {
      commit('setAnimating', true)
      commit('toggleActive', value)
      const timer = setTimeout(() => {
        commit('setAnimating', false)
        clearTimeout(timer)
        resolve(state.active)
      }, speed)
    })
  },
  toggleSearch: ({ commit, state }, value) => {
    const speed = 800
    return new Promise((resolve, reject) => {
      commit('setSearchAnimating', true)
      commit('toggleSearch', value)
      const timer = setTimeout(() => {
        commit('setSearchAnimating', false)
        clearTimeout(timer)
        resolve(state.active)
      }, speed)
    })
  },
  toggleLanguages: ({ commit, state }, value) => {
    const speed = 800
    return new Promise((resolve, reject) => {
      commit('setLanguagesAnimating', true)
      commit('toggleLanguages', value)
      const timer = setTimeout(() => {
        commit('setLanguagesAnimating', false)
        clearTimeout(timer)
        resolve(state.active)
      }, speed)
    })
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/sidebar/actions.js